/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FinalizeGoogleOauthMutationInput = {
    callbackUrl: string;
    clientMutationId?: string | null | undefined;
};
export type GoogleOAuthViewFinalizeMutationVariables = {
    input: FinalizeGoogleOauthMutationInput;
};
export type GoogleOAuthViewFinalizeMutationResponse = {
    readonly finalizeGoogleOauth: {
        readonly valid: boolean;
    } | null;
};
export type GoogleOAuthViewFinalizeMutation = {
    readonly response: GoogleOAuthViewFinalizeMutationResponse;
    readonly variables: GoogleOAuthViewFinalizeMutationVariables;
};



/*
mutation GoogleOAuthViewFinalizeMutation(
  $input: FinalizeGoogleOauthMutationInput!
) {
  finalizeGoogleOauth(input: $input) {
    valid
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FinalizeGoogleOauthMutationPayload",
    "kind": "LinkedField",
    "name": "finalizeGoogleOauth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GoogleOAuthViewFinalizeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoogleOAuthViewFinalizeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "693efa2c37511968cf384e0164ba3546",
    "id": null,
    "metadata": {},
    "name": "GoogleOAuthViewFinalizeMutation",
    "operationKind": "mutation",
    "text": "mutation GoogleOAuthViewFinalizeMutation(\n  $input: FinalizeGoogleOauthMutationInput!\n) {\n  finalizeGoogleOauth(input: $input) {\n    valid\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a375741031de77a37790bb5bea23aac4';
export default node;
